// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pn-0";
export var leftAlign = "_pn-4";
export var listItem = "_pn-2";
export var listItemWrapper = "_pn-1";
export var operationText = "_pn-3";